import React from "react";
import { Text, View } from "@react-pdf/renderer";
import QuestionResponse from "../../../exportacion_react_pdf/QuestionResponse";
import CheckboxGroup from "../../../exportacion_react_pdf/CheckboxGroup";
import TableGroup from "../../../exportacion_react_pdf/TableGroup";

// Define el documento
const ExportPaso1 = ({ formData = {}, styles = {} }) => (
  <>
    {/* Sección de Identificació del proyecto */}
    <View style={styles.section}>
      <Text style={styles.textareaLabel_1}>
        "El registro de datos personales en este formato, autoriza a la ARN para
        la recolección, almacenamiento y uso de los mismos. En cumplimiento a la
        Ley 1581/12 y el Decreto 1377/13 y las demás normas que modifiquen,
        adicionen o complementen. Conozca la política de tratamiento de los
        datos personales de la ARN a través del siguiente link:
        http://www.reintegracion.gov.co/es/atencion/Paginas/politicas.aspx”
      </Text>
      <Text style={styles.textareaLabel_1}>
        A continuación el asesor le realizará preguntas, para conocer el estado
        del proyecto productivo, verificar el estado de los activos o insumos
        con el apoyo económico entregado por la ARN durante la intervención
        anterior, determinar las necesidades de asistencia técnica e identificar
        los activos o insumos a entregar.
      </Text>
      <Text style={styles.title_1}>
        continuación encontrará preguntas para la identificación del proyecto
        productivo
      </Text>

      <Text style={styles.title_1}>I. Identificación del proyecto</Text>

      <QuestionResponse
        label={"Nombre del proyecto productivo:"}
        value={formData?.nombre_proyecto || ""}
      ></QuestionResponse>

      <CheckboxGroup
        label="Indique si es Asociativo o Individual:"
        selectedValue={formData?.asociativo_individual || ""}
        options={["Asociativo", "Individual"]}
      ></CheckboxGroup>

      <TableGroup
        questionTitle="Identificación de las Personas en Reincorporación que hacen parte del proyecto productivo:"
        headers={["nombre", "cedula", "telefono"]}
        headerDescriptions={[
          "Nombre y Apellidos",
          "Nº Cédula de ciudadanía",
          "Teléfono",
        ]}
        data={formData?.lista_participantes || []}
      />

      <QuestionResponse
        label={"Correo electrónico del proyecto productivo:"}
        value={formData?.email_participante || ""}
      ></QuestionResponse>

      <QuestionResponse
        label={"Dirección del proyecto productivo:"}
        value={formData?.direccion_proyecto || ""}
      ></QuestionResponse>

      <QuestionResponse
        label={"Departamento:"}
        value={formData?.departamento || ""}
      ></QuestionResponse>

      <QuestionResponse
        label={"Municipio:"}
        value={formData?.municipio || ""}
      ></QuestionResponse>


      <QuestionResponse
        label={"Actividad Económica del proyecto productivo:"}
        value={formData?.actividad_economica_proyecto || ""}
      ></QuestionResponse>

      <CheckboxGroup
        label="Sector Económico del proyecto productivo:"
        selectedValue={formData?.sector_economico || ""}
        options={[
          "Agrícola",
          "Pecuaria",
          "Industrial",
          "Servicios",
          "Comercio",
        ]}
      ></CheckboxGroup>

      <QuestionResponse
        label={"¿Hace cuánto esta funcionando el proyecto productivo?"}
        value={formData?.tiempo_funcionamiento_proyecto || ""}
      ></QuestionResponse>

      <QuestionResponse
        label={"El proyecto productivo tiene trabajadores?"}
        value={formData?.tiene_trabajadores || ""}
      ></QuestionResponse>

      {formData.tiene_trabajadores === "Sí" && (
        <>
          <QuestionResponse
            label={
              "¿Cuántos trabajadores hombres tiene el proyecto productivo?"
            }
            value={formData?.trabajadores_hombres || ""}
          ></QuestionResponse>

          <QuestionResponse
            label={
              "¿Cuántos trabajadores mujeres tiene el proyecto productivo?"
            }
            value={formData?.trabajadores_mujeres || ""}
          ></QuestionResponse>

          <CheckboxGroup
            label="¿Qué tipo de vinculación tienen los trabajadores de la proyecto productivo?"
            selectedValue={formData?.vinculacion_trabajadores || ""}
            options={[
              "Contrato laboral formal",
              "Prestación de servicios",
              "Acuerdo verbal",
              "No tienen vinculación",
              "Otros",
            ]}
          ></CheckboxGroup>
        </>
      )}
    </View>
  </>
);

export default ExportPaso1;
